const MediaHelpers = {
    resolveMediaUrl: (url: string) => {
        return (!url || url.match(/^http/gm)) ? url : process.env.REACT_APP_API_ENDPOINT as string + url;
    }
};

export default MediaHelpers;